import React, { useState } from "react";
import { Box, Flex, Span } from "../../assets/ui";
import { LogoMobileIcon } from "../../assets/icons";
import { IoIosArrowBack } from "react-icons/io";
import { Field } from "../common/FormElements";
import { StyledButton } from "../common/Button";
import { GoMail } from "react-icons/go";

const RequestKeyModal = ({ setActiveModal, createAccessKey }) => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const handleSubmit = e => {
    e.preventDefault();
    createAccessKey(formData);
  };

  const onChangeHandler = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <Box
      background="white"
      borderRadius="8px"
      padding="24px"
      pb={["38px", "50px"]}
      width={["90vw", "464px"]}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb={["50px", "54px"]}
      >

        <Span
          cursor="pointer"
          height="24px"
          onClick={() => setActiveModal('enterKey')}
        >
          <IoIosArrowBack size="24px" color="#233247" />
        </Span>
          <LogoMobileIcon />
      </Flex>

      <Box width={["100%", "326px"]} mx="auto">
        <Box
          textAlign="left"
          fontWeight="bold"
          fontSize="22px"
          lineHeight="32px"
          mb="32px"
          color="#233247"
        >
          Leave your details and we’ll send you an access key.
        </Box>
        <form onSubmit={handleSubmit}>
          <Field
            required
            type="text"
            name="name"
            onChange={onChangeHandler}
            label="FULL NAME"
            labelStyle={{ fontSize: "12px", mb: '8px' }}
          />
          <Field
            required
            icon={<Span position={'absolute'} bottom='10px' left='10px'><GoMail size='18px'/></Span>}
            type="mail"
            name="email"
            onChange={onChangeHandler}
            label="E-MAIL ADDRESS"
            padding={'11px 13px 14px 43px'}
            wrapperStyle={{position: 'relative'}}
            labelStyle={{ fontSize: "12px", mb: '8px' }}
          />
          <Field
            type="number"
            name="phone"
            required
            label="TELEPHONE"
            labelStyle={{ fontSize: "12px", mb: '8px' }}
            onChange={onChangeHandler}
            wrapperStyle={{ mb: ["35px", "40px"] }}
          />
          <StyledButton type="submit" width="100%">
            SUBMIT
          </StyledButton>
        </form>
      </Box>
    </Box>
  );
};

export default RequestKeyModal;
